import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c6db35e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallet-connection" }
const _hoisted_2 = ["data-network", "data-fallback-provider"]

import { NETWORK_ID } from '@/common/constants';

    interface WalletConnectionProps {
      fallbackProvider: string | null | undefined
    }


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletConnection',
  props: {
    fallbackProvider: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "data-widget": "m-connect",
      "data-wallet-connect-project-id": "b5fbaf83b34ce437fc00af569e9591b3",
      "data-network": _unref(NETWORK_ID),
      "data-fallback-provider": _ctx.fallbackProvider && _ctx.fallbackProvider.length ? _ctx.fallbackProvider : undefined,
      "data-multi": "true"
    }, null, 8, _hoisted_2)
  ]))
}
}

})